import { Vue } from 'vue-property-decorator';

Vue.filter('percent', function (value: number | string, length: number) {
    if (!length)
        length = 2;
    return Number(value).toFixed(length);
});